import { Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import MapImg from '../../assets/images/nationwide-map.png';
import Banner from '../../components/banner/Banner';
import { MapPinLayer } from '../../components/map/MapPinLayer';
import { PageMeta } from '../../components/meta/PageMeta';
import { useGetLocationsMapQuery } from '../../services/endpoints/places/location';
import { LocationMapItem } from '../../types/place.types';
import { SFCCommunity } from '../home/commonComponents/SFCCommunity';
import './NationwideSection.css';
import StateAccordionComponent from './StateAccordionComponent';

const US_STATE_NAMES: Record<string, string> = {
  AL: 'Alabama', AK: 'Alaska', AZ: 'Arizona', AR: 'Arkansas', CA: 'California',
  CO: 'Colorado', CT: 'Connecticut', DC: 'Washington, DC', DE: 'Delaware', FL: 'Florida', GA: 'Georgia',
  HI: 'Hawaii', ID: 'Idaho', IL: 'Illinois', IN: 'Indiana', IA: 'Iowa',
  KS: 'Kansas', KY: 'Kentucky', LA: 'Louisiana', ME: 'Maine', MD: 'Maryland',
  MA: 'Massachusetts', MI: 'Michigan', MN: 'Minnesota', MS: 'Mississippi', MO: 'Missouri',
  MT: 'Montana', NE: 'Nebraska', NV: 'Nevada', NH: 'New Hampshire', NJ: 'New Jersey',
  NM: 'New Mexico', NY: 'New York', NC: 'North Carolina', ND: 'North Dakota', OH: 'Ohio',
  OK: 'Oklahoma', OR: 'Oregon', PA: 'Pennsylvania', RI: 'Rhode Island', SC: 'South Carolina',
  SD: 'South Dakota', TN: 'Tennessee', TX: 'Texas', UT: 'Utah', VT: 'Vermont',
  VA: 'Virginia', WA: 'Washington', WV: 'West Virginia', WI: 'Wisconsin', WY: 'Wyoming',
};

export const NationwideSection = () => {
  const navigate = useNavigate();
  const { data: mapLocations } = useGetLocationsMapQuery();

  // Build state accordion from API data
  const stateMap = (mapLocations ?? []).reduce((acc: Record<string, LocationMapItem[]>, loc: LocationMapItem) => {
    if (!loc.state) return acc;
    if (!acc[loc.state]) acc[loc.state] = [];
    acc[loc.state].push(loc);
    return acc;
  }, {});

  const sortedStates = Object.keys(stateMap).sort((a, b) =>
      (US_STATE_NAMES[a] ?? a).localeCompare(US_STATE_NAMES[b] ?? b)
  );

  return (
      <>
        <PageMeta
            title="Locations"
            description="Sticky Fingers Cooking offers online cooking classes for kids nationwide, plus after-school programs and cooking camps in Colorado, Chicago, IL, and Austin, TX."
        />
        <div className="bg-white-header w-100">
          <Banner
              mainPageUrl="/sessions"
              mainPage="Find a cooking session"
              pageTitle="Nationwide"
              title="Finding a SFC Location near you!"
              subtitle="Everywhere you want to be"
              hideBreadcrumb
          />
        </div>

        <div className="nationwide-container">
          <Container className="nationwide-content">
            <p className="map-welcome text-center">
              Welcome to our home-grown mobile kids cooking school! Sticky Fingers Cooking does not
              have a fixed location; we are everywhere you want us to be.
            </p>

            <MapPinLayer
                mapImage={MapImg}
                locations={mapLocations ?? []}
                onSoloClick={(location) => navigate(`/franchise/${location.slug}`)}
                onGroupItemClick={(location) => navigate(`/franchise/${location.slug}`)}
            />

            <p className="explore-locations-title">Explore our Franchise Locations</p>

            <div className="w-100 states-locations">
              {sortedStates.map((stateCode) => (
                  <StateAccordionComponent
                      key={stateCode}
                      stateName={US_STATE_NAMES[stateCode] ?? stateCode}
                      stateFranchises={stateMap[stateCode]}
                  />
              ))}
            </div>
          </Container>

          <SFCCommunity contactUsPath="https://www.stickyfingerscookingfranchise.com/" />
        </div>
      </>
  );
};